module.exports = __webpack_public_path__ + "img/d201004-1.bd071caf.jpg";